import {
  Flex,
  Grid,
  GridItem,
  Nowrap,
  Picture,
  Text,
  useViewport,
} from '@farmersdog/corgi-x';
import { ExtendedText } from '../../../../components';
import { CtaButton } from './CtaButton';
import { characteristics } from './characteristics';

import {
  bowlDesktopSources,
  bowlPackMobileSources,
  packDesktopSources,
  RedX,
} from './assets';
import styles from './VetsNegativeBowlPackSection.module.css';

export const VetsNegativeBowlPackSection = () => {
  const viewport = useViewport();
  const isMobile = !viewport.lg;

  return (
    <Grid className={styles.wrapper} gap={{ xs: 'none', lg: 'xxl' }}>
      <GridItem className={styles.headingsContainer}>
        <div className={styles.titleContainer}>
          <ExtendedText
            variant={isMobile ? 'heading-28' : 'heading-36'}
            as="h2"
            id="bowl-pack-section-heading"
            weight="black"
            color="Kale3"
          >
            You shouldn’t be the only <Nowrap>one eating healthy</Nowrap>
          </ExtendedText>
        </div>
        <div className={styles.subtitleContainer}>
          <Text
            variant={isMobile ? 'heading-16' : 'heading-22'}
            as="p"
            color="Kale3"
            vSpacing="none"
          >
            We love our pets and care about their health. {isMobile && <br />}
            That’s why we started The Farmer’s Dog: <br />
            to help all dogs live longer, healthier lives.
          </Text>
        </div>
      </GridItem>
      <GridItem
        lg={6}
        direction={isMobile ? 'column' : 'row-reverse'}
        justify={isMobile ? 'center' : 'flex-end'}
        alignItems="center"
      >
        <div className={styles.imageContainer}>
          <Picture
            sources={[...bowlPackMobileSources, ...bowlDesktopSources]}
            alt="Turkey Bowl"
            loading="lazy"
            className={styles.bowlImage}
          />
        </div>
      </GridItem>
      {!isMobile && (
        <div className={styles.packImageContainer}>
          <Picture
            sources={packDesktopSources}
            alt="Turkey Pack"
            loading="lazy"
            className={styles.packImage}
          />
        </div>
      )}
      <GridItem lg={6} className={styles.characteristicsGridContainer}>
        <Grid gap={20}>
          {characteristics.map(characteristic => (
            <GridItem
              xs={6}
              lg={12}
              direction={{ xs: 'column', lg: 'row' }}
              alignItems={{ xs: 'center', lg: 'flex-start' }}
              className={styles.characteristicsGridItem}
              key={characteristic.title}
            >
              <RedX width={21} />
              <Flex
                direction="column"
                alignItems={{ xs: 'center', lg: 'flex-start' }}
                className={styles.characteristicsGridItemText}
              >
                <Text variant={isMobile ? 'heading-16' : 'heading-20'} bold>
                  {characteristic.title}
                </Text>
                <Text
                  align={isMobile ? 'center' : 'left'}
                  variant={isMobile ? 'heading-12' : 'heading-20'}
                  color={isMobile ? 'Charcoal2' : 'Charcoal3'}
                >
                  {characteristic.description}
                </Text>
              </Flex>
            </GridItem>
          ))}
        </Grid>
        {!isMobile && <CtaButton />}
      </GridItem>
      {isMobile && <CtaButton />}
    </Grid>
  );
};
